@let state = info();
@if (state?.show) {
  <div
    class="info-overlay"
    [class.info-right]="state?.alignRight"
    [innerHTML]="state?.message | safe: 'html'"
  ></div>
}
